import "react-phone-input-2/lib/style.css";

import * as Yup from "yup";

import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { ConnectedFocusError } from "focus-formik-error";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Select from "react-select";
import TextError from "../TextError";
import ToolTip from "../ToolTip";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import { validateUserName,validateEmail,validateMobileNo } from "./AllValidation";
import { postCustomerEntry } from "../../Service/AllCustomerEntryAPI";
import swal from "sweetalert";

const customerDesignationList = [
  { value: "government", label: "Government" },
  { value: "private", label: "Private" },
  { value: "other", label: "Other" },
];

const phoneRegEx = "^([0|+[0-9]{1,5})?([7-9][0-9]{9})$"; // ----- validate Phone No
const pincodeRegEx = "^[1-9]{1}[0-9]{2}[0-9]{3}$"; // ----- validate PinCode

/* ----- declaration of validationSchema validation (based on the object schema provided by Yup) and display of
  validation errors ----- */
const validationSchema = Yup.object().shape({
 
  customerName: Yup.string()
    .required("Required *")
    .min(2, "Too Short!")
    .matches(/^[A-Za-z\s]+$/, "Customer name must only contain letters "),

  customerEmailId: Yup.string()
    .required("Required *")
    .email("Invalid email")
    .test("com", "Email must include .com", (value) => {
      if (value && !value.includes(".com")) {
        return false;
      }
      return true;
    }),
  customerMobileNo: Yup.string()
    .required("Required *")
    .matches(/^[0-9\s]+$/, "Enter Numbers Only")
    .test("valid-phone", "Invalid Mobile number", (value) => {
      if (!value) return false;
      const cleanedNumber = value.replace(/\s/g, "");
      return /^\d{10}$/.test(cleanedNumber);
    })
    .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
    .matches(phoneRegEx, "Mobile number is not valid"),
  contactPersonName: Yup.string()
    .required("Required *")
    .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
    .min(2, "Too Short!"),
  userName: Yup.string()
    .required("Required *")
    .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
    .min(2, "Too Short!"),
  password: Yup.string()
    .required("Required *")
    .min(8, "Password must be 8 characters long")
    .matches(/[0-9]/, "Must contain at least 1 digit (0-9)")
    .matches(/[a-z]/, "Must contain at least 1 lowercase letter (a-z)")
    .matches(/[A-Z]/, "Must contain at least 1 uppercase letter (A-Z)")
    .matches(/[^\w]/, "Must contain at least 1 symbol"),
  customerType: Yup.string().required("Required *"),
  contactPersonDesignation: Yup.string().required("Required *"),
  contactEmailId: Yup.string()
    .email("Invalid email")
    .required("Required *")
    .test("com", "Email must include .com", (value) => {
      if (value && !value.includes(".com")) {
        return false;
      }
      return true;
    }),
  contactPhoneNo: Yup.string()
    .required("Required *")
    .matches(phoneRegEx, "Phone number is not valid")
    .matches(/^\d{10}$/, "Phone number must be 10 digits"),
 city: Yup.string()
    .required("Required *")
    .matches(/^[A-Za-z\s]+$/, "City must only contain alphabets"),
  pinCode: Yup.string()
    .required("Required *")
    .matches(pincodeRegEx, "Pincode is not valid"),
  siteName: Yup.string().required("Required *"),
  customerAddress: Yup.string().required("Required *"),
  desc: Yup.string()
    .required("Required *")
    .min(4, "It should have minimum 4 characters!")
    .max(225, "It should have maximum 225 characters!"),
});

export default () => {
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [value, setValue] = useState();
  const [isLoaded, setisLoaded] = useState(false);
  const [eyePass, setEyePass] = useState(false);
  const [validateUserNm, setvalidateUserNm] = useState([]);
  const eyeTogglePass = () => {
    setEyePass(!eyePass);
  };

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        var form = event.target.form;
        var index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    });
  }, []);

  return (
    <Formik
      // ----- Declaration of initialValues
      initialValues={{
        customerName: "",
        customerEmailId: "",
        customerMobileNo: "",
        contactPersonName: "",
        userName: "",
        password: "",
        customerType: "",
        contactPersonDesignation: "",
        contactEmailId: "",
        contactPhoneNo: "",
        city: "",
        pinCode: "",
        siteName: "",
        customerAddress: "",
        desc: "",
      }}
      // ----- Function call to validationSchema
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm }) => {
        // ----- declaration of onSubmit callback
        setisLoaded(true);
        try {
          // ----- code that we will 'try' to run
          const loginUserName = sessionStorage.getItem("userName");
          const loginRole = sessionStorage.getItem("role");
          // ----- All Object for add customer data
          const data = {
            customerName: values.customerName,
            customerEmailId: values.customerEmailId.toLowerCase(),
            customerMobileNo: values.customerMobileNo,
            customerAddress: values.customerAddress,
            contactPersonName: values.contactPersonName
              .toLowerCase()
              .split(" ")
              .map((word) => word.trim())
              .filter((word) => word !== "")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")
              .trimStart()
              .trimEnd(),
            customerType: values.customerType,
            contactPersonDesignation: values.contactPersonDesignation,
            contactEmailId: values.contactEmailId.toLowerCase(),
            contactPhoneNo: values.contactPhoneNo,
            country: country,
            state: state,
            city: values.city,
            siteName: values.siteName,
            pinCode: values.pinCode,
            discription: values.desc,
            userName: values.userName
              .toLowerCase()
              .split(" ")
              .map((word) => word.trim())
              .filter((word) => word !== "")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")
              .trimStart()
              .trimEnd(),
            password: values.password,
            createdBy: `${loginUserName}`,
          };
          console.log("Customer Data :-", data);
          const token = sessionStorage.getItem("token");
          const headers = { Authorization: `Bearer ${token}` };
          setTimeout(async () => {
            await postCustomerEntry(data, headers)
              .then((result) => {
                setisLoaded(false);
                console.log("Customer Result", result);
                if (result.data.message === "mobile no already exist") {
                  swal("Failed", "Registered Mobile No already exists", "warning");
                } else if (result.data.message === "email-id already exists") {
                  swal("Failed", "Email ID already exists", "warning");
                } else if (result.data.message === "username already exist") {
                  swal("Failed", "Username already exists", "warning");
                } else {
                  swal("Great", "Customer user created successfully...", "success");
                  resetForm();
                }
                
              })
              .catch((error) => {
                console.log("Customer Error", error);
                setisLoaded(false);
                if (error.response.status === 400) {
                  console.log("error.response.data :-", error.response.data);
                  let customerVal = error?.response?.data;
                  if (customerVal?.customerName !== undefined) {
                    swal("Failed", "Please Enter Customer Name", "warning");
                    return false;
                  }
                  if (customerVal?.customerEmailId !== undefined) {
                    swal(
                      "Failed",
                      "Please Enter Registered Email Id",
                      "warning"
                    );
                    return false;
                  }
                  if (customerVal?.customerMobileNo !== undefined) {
                    swal(
                      "Failed",
                      "Please Enter Registered Mobile Number",
                      "warning"
                    );
                    return false;
                  }
                  if (customerVal?.contactPersonName !== undefined) {
                    swal(
                      "Failed",
                      "Please Enter Contact Person Name",
                      "warning"
                    );
                    return false;
                  }
                  if (customerVal?.userName !== undefined) {
                    swal("Failed", "Please Enter User Name", "warning");
                    return false;
                  }
                  if (customerVal?.password !== undefined) {
                    swal("Failed", "Please Enter Password", "warning");
                    return false;
                  }
                  if (customerVal?.customerType !== undefined) {
                    swal("Failed", "Please Enter Customer Type", "warning");
                    return false;
                  }
                  if (customerVal?.contactPersonDesignation !== undefined) {
                    swal(
                      "Failed",
                      "Please Enter Contact Person Designation",
                      "warning"
                    );
                    return false;
                  }
                  if (customerVal?.contactEmailId !== undefined) {
                    swal(
                      "Failed",
                      "Please Enter Contact Person EmailId",
                      "warning"
                    );
                    return false;
                  }
                  if (customerVal?.contactPhoneNo !== undefined) {
                    swal(
                      "Failed",
                      "Please Enter Contact Person Mobile No",
                      "warning"
                    );
                    return false;
                  }
                  if (customerVal?.country !== undefined) {
                    swal("Failed", "Please Select Country", "warning");
                    return false;
                  }
                  if (customerVal?.state !== undefined) {
                    swal("Failed", "Please Select State", "warning");
                    return false;
                  }
                  if (customerVal?.city !== undefined) {
                    swal("Failed", "Please Enter City", "warning");
                    return false;
                  }
                  if (customerVal?.pinCode !== undefined) {
                    swal("Failed", "Please Enter PinCode", "warning");
                    return false;
                  }
                  if (customerVal?.siteName !== undefined) {
                    swal("Failed", "Please Enter Site Name", "warning");
                    return false;
                  }
                  if (customerVal?.discription !== undefined) {
                    swal("Failed", "Please Enter Description", "warning");
                    return false;
                  }
                } else {
                  swal(
                    "Failed",
                    "Something went wrong please check your internet",
                    "error"
                  );
                }
              });
          }, 200);
        } catch (error) {
          // ----- code to run if there are any problems
          console.log(error);
          setisLoaded(false);
          swal(
            "Failed",
            "Something went wrong please check your internet",
            "error"
          );
        }
      }}
    >
      {(formik) => {

         const { isValid, dirty, isSubmitting } = formik;
         const isbuttondisable = state && country;
        // ----- Formik provides the Form, Field and ErrorMessage
        return (
          <>
            {isLoaded ? (
              <div className="reportload"></div>
            ) : (
              <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                  <div className="d-flex">
                    <Link
                      to="customer-entry-report"
                      className="fieldLink btn btn-primary"
                    >
                      <FontAwesomeIcon icon={faClipboard} className="me-2" />{" "}
                      Reports
                      <span className="icon icon-small ms-1"></span>
                    </Link>
                  </div>
                </div>
                <Card border="light" className="bg-white shadow-sm mb-4">
                  <Card.Body>
                    <h5 className="head mb-4">New Customer Entry Form</h5>
                    {/* react-final-form */}
                    <Form>
                      <ConnectedFocusError />
                      <Row>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Customer Name *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Customer Name (Only alphabets allowed)"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="customerName"
                                  placeholder="Enter Customer Name "
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="customerName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Registered Email *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Registered Email"
                                direction="bottom"
                              >
                                <Field
                                  type="email"
                                  className="form-control"
                                  name="customerEmailId"
                                  placeholder="Enter Registered Email"
                                  validate={validateEmail}
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="customerEmailId"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Registered Mobile No. *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Registered Mobile No"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  maxLength="10"
                                  className="form-control"
                                  name="customerMobileNo"
                                  placeholder="Enter Registered Mobile No."
                                  validate={validateMobileNo}
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="customerMobileNo"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Contact Person Name *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Contact Person Name"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="contactPersonName"
                                  placeholder="Enter Contact Person Name "
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="contactPersonName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Username *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Username"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="userName"
                                  placeholder="Enter Username "
                                  autoComplete="off" 
                                  validate={validateUserName}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="userName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Password *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter 8 digit password"
                                direction="bottom"
                              >
                                <Field
                                  type={eyePass ? "text" : "password"}
                                  className="form-control"
                                  name="password"
                                  placeholder="Enter Password "
                                />
                              </ToolTip>
                            </div>
                            <span className="p-eye1" onClick={eyeTogglePass}>
                              <FontAwesomeIcon
                                icon={eyePass ? faEyeSlash : faEye}
                              />
                            </span>
                            <ErrorMessage
                              name="password"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Select Customer Type *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Customer Type"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Customer Type"
                                  options={customerDesignationList}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "customerType",
                                      e.value
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="customerType"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Contact Person Designation *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Contact Person Designation"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="contactPersonDesignation"
                                  placeholder="Enter Person Designation"
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="contactPersonDesignation"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Contact Person Email *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Contact Email"
                                direction="bottom"
                              >
                                <Field
                                  type="email"
                                  className="form-control"
                                  name="contactEmailId"
                                  placeholder="Enter Contact Email"
                                  autoComplete="off" 
                                  validate={validateEmail}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="contactEmailId"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Contact Person Mobile No. *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Contact Mobile No"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  maxLength="10"
                                  className="form-control"
                                  name="contactPhoneNo"
                                  placeholder="Enter Contact Mobile No."
                                  autoComplete="off" 
                                  validate={validateMobileNo}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="contactPhoneNo"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Registered Address *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Register Address"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  rows="2"
                                  className="form-control"
                                  name="customerAddress"
                                  placeholder="Enter Register Address"
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="customerAddress"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Country</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Country"
                                direction="bottom"
                              >
                                <CountryDropdown
                                  className="form-control"
                                  id="country"
                                  value={country}
                                  onChange={(val) => setCountry(val)}
                                  priorityOptions={["IN"]}
                                />
                              </ToolTip>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">State</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select State"
                                direction="bottom"
                              >
                                <RegionDropdown
                                  className="form-control"
                                  id="state"
                                  country={country}
                                  value={state}
                                  onChange={(val) => setState(val)}
                                  priorityOptions={{
                                    IN: ["MH"],
                                  }}
                                />
                              </ToolTip>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">City *</label>
                            <div className="example-wrapper">
                              <ToolTip content="Enter City" direction="bottom">
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="city"
                                  placeholder="Enter City"
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Pin Code *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Pin Code"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="pinCode"
                                  placeholder="Enter Pin Code"
                                  maxLength="6"
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="pinCode"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Site Name *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Site Name"
                                direction="bottom"
                              >
                                <Field
                                  className="form-control"
                                  name="siteName"
                                  placeholder="Enter Site Name"
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="siteName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Description *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Description"
                                direction="bottom"
                              >
                                <Field
                                  as="textarea"
                                  rows="3"
                                  maxLength={100}
                                  className="form-control"
                                  name="desc"
                                  placeholder="Enter Description"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage name="desc" component={TextError} />
                          </div>
                        </Col>
                      </Row>
                      <div className="mt-3">
                        <Button
                          variant="primary"
                          type="submit"
                          disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting || ! isbuttondisable }
                          
                        >
                          Create Customer
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </>
            )}
          </>
        );
      }}
    </Formik>
  );
};
